import { createStore } from 'zustand/vanilla';

const createErpListsStore = (supabaseClient, getUserId) => {
  if (!supabaseClient) {
    throw new Error('Supabase client is required');
  }
  if (!getUserId || typeof getUserId !== 'function') {
    throw new Error('getUserId function is required');
  }

  return createStore((set, get) => ({
    locations: [],
    costCenters: [],
    departments: [],
    isLoading: false,
    error: null,

    fetchLists: async () => {
      set({ isLoading: true, error: null });
      try {
        const userId = getUserId();
        
        const [locsRes, ccRes, deptsRes] = await Promise.all([
          supabaseClient.from('invoice_erp_locations').select('codigo, descripcion').eq('tenant_id', userId).order('codigo'),
          supabaseClient.from('invoice_erp_cost_centers').select('codigo, descripcion').eq('tenant_id', userId).order('codigo'),
          supabaseClient.from('invoice_erp_departments').select('codigo, descripcion').eq('tenant_id', userId).order('codigo')
        ]);

        if (locsRes.error) throw locsRes.error;
        if (ccRes.error) throw ccRes.error;
        if (deptsRes.error) throw deptsRes.error;

        set({
          locations: locsRes.data || [],
          costCenters: ccRes.data || [],
          departments: deptsRes.data || [],
          isLoading: false
        });
      } catch (error) {
        console.error('Error fetching ERP lists:', error.message);
        set({ error: error.message, isLoading: false });
      }
    }
  }));
};

export default createErpListsStore;
